import React from 'react'
import Container from '@mui/material/Container';
import Grid2 from '@mui/material/Grid2';
import Link from '@mui/material/Link';
import { Link as RouterLink} from 'react-router-dom';
import Typography from '@mui/material/Typography'

const Footer = () => {
    return (
        <Container maxWidth={false} sx={{marginTop: 'auto', marginBottom: '1rem', textAlign: 'center'}}>
            <Grid2 container spacing={2}>
                < Grid2 size={4}><Typography><Link component={RouterLink} to='/contact'>Help & Contact</Link></Typography></Grid2>
                < Grid2 size={4}><Typography><Link component={RouterLink} to='/terms'>Terms and Conditions</Link></Typography></Grid2>
                <Grid2 size={4}><Typography><Link component={RouterLink} to='/legal'>Legal</Link></Typography></Grid2>
            </Grid2>
            <Grid2 container>
                <Grid2 style={{textAlign: "center"}} size={12} ><Typography>© 2008-{`${new Date().getFullYear()}`} Justice Systems Inc.; Neumo LLC - All rights reserved.</Typography></Grid2>
            </Grid2>
        </Container>
    );
}

export default Footer
